<script lang="ts">
	import AriaText from "@components/common/AriaText.svelte";
	import type { HTMLAnchorAttributes } from "svelte/elements";
	import { isEnum } from "@core/utils/enum/isEnum.js";
	import { ButtonVariant } from "./getButtonClass.js";
	import { getButtonClass } from "./getButtonClass.js";
	import { type LinkVariant, getLinkClass } from "./getLinkClass.js";

	const isButtonVariant = isEnum(ButtonVariant);
	const {
		variant,
		...rest
	}: { variant?: ButtonVariant | LinkVariant } & Omit<HTMLAnchorAttributes, "download"> & { download?: string } =
		$props();

	// Opening external links in a new tab is opt-in via the `target` prop (not automatic);
	// when the caller asks for a new tab, default to a safe `rel` unless they override it.
	const target = $derived(rest.target);
	const rel = $derived(rest.rel ?? (rest.target === "_blank" ? "noopener noreferrer" : undefined));
</script>

<a
	{...rest}
	{target}
	{rel}
	class={[isButtonVariant(variant) ? getButtonClass(variant) : getLinkClass(variant), rest.class]}
>
	<AriaText aria={rest["aria-label"] ?? ""}>
		{@render rest.children?.()}
	</AriaText>
</a>
